import {Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'break-dialog',
    templateUrl: 'break.dialog.html',
})
export class BreakDialog {
    constructor(@Inject(MAT_DIALOG_DATA) public data: {
        feedback: boolean,
        correctAnswersCount: number,
        totalAnswersCount: number,
        avgResponseTime: string,
        percentage: string
    },
    public translate: TranslateService){

    }
}
